import { useCallback, useEffect, useRef, useState } from "react";
import { fetchWorkItemSummaries } from "../../services/workItemsService";
import { onWorkItemsChanged } from "../../utils/workItemsBus";

// { [summaryKey]: { comments, rejection } } for the given tasks/orders: each
// row's 💬 count and its latest rejection message. Refreshes whenever the host
// hands it a new list (the Tasks tab reloads every 30 s, which is how other
// people's comments show up) and after any task/order change here.
export default function useWorkItemSummaries(items) {
  const [summaries, setSummaries] = useState({});
  const refs = (items || []).filter((i) => i && i.id && (i.kind === "task" || i.kind === "order"));
  const refsRef = useRef(refs);
  refsRef.current = refs;

  const load = useCallback(async () => {
    const current = refsRef.current;
    if (!current.length) {
      setSummaries({});
      return;
    }
    try {
      const res = await fetchWorkItemSummaries(current);
      setSummaries(res?.summaries || {});
    } catch (err) {
      console.warn("Work items: could not load comment counts", err);
    }
  }, []);

  // The list itself, not its keys: a reload brings the same items in a new list.
  useEffect(() => {
    load();
  }, [items, load]);
  useEffect(() => onWorkItemsChanged(() => load()), [load]);
  return summaries;
}
